export interface Capability {
  text: string;

  image: string;
}
